import { render, staticRenderFns } from "./TabbedEditorHeaderCard.vue?vue&type=template&id=79b11a76&scoped=true&"
import script from "./TabbedEditorHeaderCard.vue?vue&type=script&lang=js&"
export * from "./TabbedEditorHeaderCard.vue?vue&type=script&lang=js&"
import style0 from "./TabbedEditorHeaderCard.vue?vue&type=style&index=0&id=79b11a76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b11a76",
  null
  
)

export default component.exports